import React from 'react';
import styled from 'styled-components';
import { Skeleton } from 'fpay-ui';

export const Table = styled.div`
  margin-top: 16px;
  padding: 0px 24px;
  height: ${(props) => (props.tableHeight ? '200px' : '350px')};
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d6d6d6;
    height: 20px;
    border-radius: 10px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-left: 8px;
  padding-left: 8px;
  margin-bottom: 12px;
`;

export const RowBody = styled.div`
  padding: 9px 8px 7px 8px;
  border-radius: 8px;
  background: var(--gray-gray-25, #fafafa);
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => (props.bottom ? '50px' : '8px')};
`;

const SkeletonTitle = styled(Skeleton)`
  max-width: 97px;
  height: 12px;
  margin-top: 29px;
  margin-bottom: 24px;
`;

const SkeletonTab = styled(Skeleton)`
  max-width: 97px;
  height: 19px;
  margin-top: 29px;
  margin-bottom: 24px;
`;

const TableSkeleton = () => (
  <>
    <Table>
      <HeaderRow>
        <SkeletonTitle />
        <SkeletonTitle />
        <SkeletonTitle />
        <SkeletonTitle />
        <SkeletonTitle />
        <SkeletonTitle />
        <SkeletonTitle />
        <SkeletonTitle />
      </HeaderRow>
      <RowBody>
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
      </RowBody>
      <RowBody>
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
        <SkeletonTab />
      </RowBody>
    </Table>
  </>
);
export default TableSkeleton;
